import {
  treatsItem,
  treatsItems,
} from '@/business/apiTreatment/response/baseAPITreatment';
import BaseService from '@/services/services/tools/baseService';
import RequestsAPI from '@/services/api/internal/requests.api';

const datetimeFieldNames = [
  'signalisation_datetime',
  'expiration_datetime',
  'limit_datetime',
];

const LightRequestsService = new BaseService({
  api: RequestsAPI,
  treatCurrentResponse: treatsItem({ datetimeFieldNames }),
  treatListResponse: treatsItems({ datetimeFieldNames }),
});
LightRequestsService.updateLimitDatetime = (id, date) => {
  return RequestsAPI.updateLimitDatetime(id, {
    limit_datetime: date,
  });
};

const RequestsService = new BaseService({
  api: RequestsAPI,
  urlParamsItems: { expand: 'intervention,property,customer_files' },
  urlParamsCurrent: { expand: 'intervention,property' },
  treatCurrentResponse: treatsItem({ datetimeFieldNames }),
});

export { LightRequestsService };
export default RequestsService;
